import React, { FC, HTMLProps } from 'react';
import Button from 'components/Button/Button';
import styles from './ConfirmAction.module.css';

type ConfirmActionProps = HTMLProps<HTMLDivElement> & {
    onCancel: () => void;
    onConfirm: () => void;
    loading: boolean;
    action?: string;
};

const ConfirmAction: FC<ConfirmActionProps> = ({
    onCancel,
    onConfirm,
    loading,
    action = 'Delete',
    children,
    ...restProps
}) => {
    return (
        <div className={styles.container} {...restProps}>
            {children}
            <div className={styles.buttonRow}>
                <Button color="error" size="md" onClick={onConfirm} disabled={loading}>
                    Yes
                </Button>
                <Button color="info" size="md" onClick={onCancel} disabled={loading}>
                    No, Don't {action}
                </Button>
            </div>
        </div>
    );
};

export default ConfirmAction;
